import { HttpContextToken } from '@angular/common/http';

// Kept free of app imports so the store can read these without an import cycle through the interceptor

export const IS_EXTENDED_ERRORS = new HttpContextToken<boolean>(() => false);
export const SKIP_ERROR_NOTIFICATION = new HttpContextToken<boolean>(() => false);
export const CUSTOM_ERROR_MESSAGE = new HttpContextToken<string>(() => '');
// For a caller that handles the failure itself, such as the login's linked business accounts lookup: a
// 500 on a session endpoint must not log out the session that caller is still setting up
export const SKIP_SESSION_LOGOUT = new HttpContextToken<boolean>(() => false);
